<template>
  <div class="list-page-container">
    <div class="breadcrumbs">产品中心</div>
    <div class="header-button">
      <el-button type="success" icon="el-icon-document-add" @click="addProduct()">新增</el-button>
    </div>
    <div class="list-page-wrap">
      <!-- 顶部操作栏 -->
      <div class="list-page-heaser">
        <el-form ref="searchForm" class="header-search" :model="searchData" @keydown.enter.native="searchSubmit">
          <el-form-item label="产品名称" prop="product_name">
            <el-input v-model="searchData.product_name" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品类型" prop="product_type_id">
            <el-select v-model="searchData.product_type_id" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-search" @click="searchSubmit()">查询</el-button>
            <el-button @click="resetSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 列表数据 -->
      <Product-overview-card :data="tableData" :pagination="pagination" @current-page-change="handleCurrentChange"
        @size-change="handleSizeChange" @edit-product="handleEditProduct" @delete-product="deleteListRow">
      </Product-overview-card>
    </div>
    <!-- 新增 -->
    <el-dialog :title="addProductTitle" width="1000px" custom-class="near" :append-to-body="true"
      :close-on-click-modal="false" :visible.sync="addProductVisible" @closed="closeAddProductDialog()"
      @opened="onDialogOpened">
      <el-form ref="addProductForm" :rules="addProductRules" :model="addProductData" label-position="top">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="产品名称" prop="name">
              <el-input v-model="addProductData.name" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品类型" prop="product_type_id">
              <el-select v-model="addProductData.product_type_id" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.label" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="产品规格" prop="spec">
              <!-- 替换为UEditor -->
              <UEditor ref="editorRef" :uploadUrl="uploadUrl" :img-url-prefix="imageUrlprefix"
                v-model="addProductData.spec" :height="500" :show-source-btn="true" :allow-paste-html="true" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="产品描述" prop="description">
              <el-input v-model="addProductData.description" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="产品图片" prop="img_id">
              <el-upload class="avatar-uploader" drag :show-file-list="false" :action="uploadUrl"
                :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="热门产品" prop="hot" class="horizontal-item">
              <el-switch v-model="addProductData.hot" active-color="#32B768"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="产品序号" prop="position">
              <el-input v-model="addProductData.position" placeholder="请从1开始"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="text-right">
              <el-button @click="addProductVisible = false">取消</el-button>
              <el-button type="success" @click="addProductSubmit()">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/api'
import listMixin from '@/mixins/listMixin'
import * as DICT from '@/utils/dict/fieldDictionary'
import ProductOverviewCard from './product-overview-card.vue'
// 引入UEditor组件替换QuillEditor
import UEditor from '@/components/UEditor.vue'

export default {
  name: 'DeviceOverviewAata',
  mixins: [listMixin],
  components: {
    ProductOverviewCard,
    UEditor // 注册UEditor组件
  },
  data() {
    return {
      dataDict: DICT,
      typeList: [],
      uploadUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_UPLOAD.url}?token=${localStorage.getItem('token')}`,
      imageUrl: '',
      imageUrlprefix: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}`,
      // 列表相关数据
      searchData: {
        product_name: '',
        product_type_id: null
      },
      pagination: {
        currentPage: 1,
        pageSize: 6,
        total: 0
      },
      queryListApi: apis.QUERY_PRODUCT_LIST,
      deleteListParams: {
        api: apis.DELETE_PRODUCT,
        id: 'id'
      },
      addProductTitle: '新增产品',
      addProductVisible: false,
      addProductData: {
        name: '',
        description: '',
        product_type_id: '',
        spec: '',
        img_id: '',
        hot: true,
        position: ''
      },
      addProductRules: {
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        product_type_id: [
          { required: true, message: '请选择产品类型', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请输入产品序号', trigger: 'blur' }
        ]
      },
      pendingSpec: null // 用于编辑时暂存规格数据
    }
  },
  mounted() {
    this.queryType()
  },
  methods: {
    onDialogOpened() {
      // 编辑器打开时设置内容
      this.$nextTick(() => {
        if (this.pendingSpec && this.$refs.editorRef) {
          this.$refs.editorRef.setContent(this.pendingSpec)
          this.pendingSpec = null
        }
      })
    },
    closeAddProductDialog() {
      this.addProductData = {
        id: '',
        name: '',
        description: '',
        product_type_id: '',
        spec: '',
        img_id: '',
        hot: true,
        position: ''
      }
      this.imageUrl = ''
      this.$nextTick(() => {
        this.$refs.addProductForm.clearValidate()
        // 清空编辑器内容
        if (this.$refs.editorRef) {
          this.$refs.editorRef.setContent('')
        }
      })
    },
    handleImageSuccess(res, file) {
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${res.data.id}`
      this.addProductData.img_id = res.data.id
    },
    beforeImageUpload(file) {
      const isImg = ['image/jpeg', 'image/png'].includes(file.type)

      if (!isImg) {
        this.$message.error('只能上传图片格式!')
      }
      return isImg
    },
    queryType() {
      this.typeList = []
      const request = {
        ...apis.QUERY_PRODUCT_TYPE
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.typeList = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    addProduct() {
      this.addProductTitle = '新增产品'
      this.addProductVisible = true
      // 清空编辑器内容
      this.$nextTick(() => {
        if (this.$refs.editorRef) {
          this.$refs.editorRef.setContent('')
        }
      })
    },
    handleEditProduct(item) {
      this.addProductTitle = '编辑产品'
      this.addProductVisible = true

      // 映射行数据到对话框表单
      this.addProductData = {
        id: item.id,
        name: item.name,
        description: item.description,
        product_type_id: item.product_type_id,
        spec: item.spec,
        img_id: item.img_id,
        hot: item.hot === 2,
        position: item.position
      }
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${item.img_id}`
      // 暂存规格数据，在对话框打开后设置到编辑器
      this.pendingSpec = item.spec
    },
    addProductSubmit() {
      this.$refs.addProductForm.validate((valid) => {
        if (!valid) {
          return false
        }

        this.addProductData.hot = this.addProductData.hot ? 2 : 1
        this.addProductData.position = parseInt(this.addProductData.position)

        let request = {}
        if (this.addProductData.id) {
          request = {
            url: '/api/v1/admin/products/' + this.addProductData.id,
            method: 'put',
            disableSuccessMsg: true,
            disableErrorMsg: false,
            params: {
              ...this.addProductData
            }
          }
        } else {
          request = {
            ...apis.SAVE_PRODUCT,
            params: {
              ...this.addProductData
            }
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                this.queryListData()
                this.addProductVisible = false
              }
            },
            (err) => {
              console.error(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
          })
      })
    }
  }
}
</script>

<style scoped>
.el-select {
  width: 100%;
}

.avatar-uploader .el-upload {
  width: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.el-upload-dragger {
  width: 100%;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  max-width: 100%;
  max-height: 100%;
}
</style>
